import React, { useCallback } from 'react';
import styles from './page.module.css';
import { useUserContext } from '@/contexts/UserContext';
import { useIntercom } from 'react-use-intercom';

const SupportPage = () => {
  const { user, seller, logout } = useUserContext();
  const intercom = useIntercom();

  const showHelpChat = useCallback(() => {
    sessionStorage.setItem("show-intercom", "true");
    try {
      intercom.update({ name: user?.name, email: user?.email, hideDefaultLauncher: false });
      intercom.show();
    } catch (err) {
      console.error(err);
    }
  }, [intercom, user]);

  return (
    <div className={styles.pageContainer}>
        <div className={styles.container}>
        <div className={styles.sectionWrapper}>
            <section className={styles.section}>
            <h2 className={styles.sectionTitle}>Need Help?</h2>
            <p className={styles.sectionDescription}>
                Need assistance? We're here to help! Find answers, troubleshoot issues, and get support whenever you need it.
            </p>
            <button 
              onClick={showHelpChat} 
              className={styles.actionButton}
            >
              Help
            </button>
            </section>
        </div>

        <div className={styles.divider}></div>

        <div className={styles.sectionWrapper}>
            <section className={styles.section}>
            <h2 className={styles.sectionTitle}>Find a Bug?</h2>
            <p className={styles.sectionDescription}>
                Noticed something not working as expected? Help us improve by reporting any bugs or glitches you encounter.
            </p>
            <button 
              onClick={showHelpChat} 
              className={styles.actionButton}
            >
              Report Bug
            </button>
            </section>
        </div>

        <div className={styles.divider}></div>

        <div className={styles.sectionWrapper}>
            <section className={styles.section}>
            <h2 className={styles.sectionTitle}>Feature Request</h2>
            <p className={styles.sectionDescription}>
                Got an idea to improve the app? We'd love to hear it! Share your feature requests and help shape future updates.
            </p>
            <a 
              href="https://www.boxem.com/feature-request" 
              target="_blank" 
              rel="noopener noreferrer" 
              className={styles.actionButton}
            >
              Request Feature
            </a>
            </section>
        </div>

        <div className={styles.divider}></div>

        <div className={styles.sectionWrapper}>
            <section className={styles.section}>
            <h2 className={styles.sectionTitle}>Earn 30% Commission</h2>
            <p className={styles.sectionDescription}>
              Earn recurring monthly commission for every user you refer to Boxem.
            </p>
            <a 
              href="https://www.boxem.com/affiliate-program" 
              target="_blank" 
              rel="noopener noreferrer" 
              className={styles.actionButton}
            >
              Earn Commission
            </a>
            </section>
        </div>
        </div>
    </div>
  );
};

export default SupportPage;